import React, {useState} from 'react';
import SlideShow from '../SlideShow/SlideShow';
import { GetCart, Increment, Decrement, Remove } from '../ShoppingCart/CartHandler.js'
import { Suspense } from 'react';

const FeaturedCards = React.lazy(() => import('../FeaturedCards/FeaturedCards'));
const PopularCards = React.lazy(() => import('../PopularCards/PopularCards'));
const NewCard = React.lazy(() => import('../NewCards/NewCards'));

function HomePage(props) {
    const [slides, setSlides] = useState ([])

    const [cart, setCart] = useState(GetCart());

            return(

        
        <div className = 'flex-col fill center'>
            <SlideShow className = 'flex-row full-width center' fallback = {<div>Slides Are Loading....</div>} slides = {slides} setSlides = {setSlides}></SlideShow>
            <div id="productContainer">
                    <br />
                    <h3 className = 'flex-row full-width center' >Featured Products</h3>
                    <br />
                    <Suspense className = 'flex-row full-width center' fallback={<div>Loading...</div>}>
                        <FeaturedCards  setCartFunc={setCart}   
                                        token = {props.token}                         
                                        category = {props.category} setCategory = {props.setCategory}
                                        categories = {props.categories} setCategories = {props.setCategories}
                                        cartCount = {props.cartCount} setCartCount = {props.setCartCount}/>
                    </Suspense>
                    <br />
                    <h3 className='popular'>Most Popular</h3>
                    <br/>
                    <Suspense className = 'flex-row full-width center'fallback={<div>Loading...</div>}>
                        <PopularCards   setCartFunc={setCart} 
                                        token = {props.token} 
                                        category = {props.category} setCategory = {props.setCategory} 
                                        categories = {props.categories} setCategories = {props.setCategories}
                                        cartCount = {props.cartCount} setCartCount = {props.setCartCount}/>
                    </Suspense>
                    <br />
                    <h3 className='new-products'>New Products</h3>
                    <br />
                    <Suspense className = 'flex-row full-width center'fallback={<div>Loading...</div>}>
                        <NewCard    setCartFunc={setCart}  
                                    token = {props.token} 
                                    category = {props.category} setCategory = {props.setCategory} 
                                    categories = {props.categories} setCategories = {props.setCategories}
                                    cartCount = {props.cartCount} setCartCount = {props.setCartCount}/>
                    </Suspense>
                </div>
        </div>
        );
};

export default HomePage;



